import React from 'react';
import { useLogin } from '../../../auth/useLogin';

export const RegistrationRedirect: React.FC = () => {
    return <>{useLogin()}</>;
};
